import styles from "./turtleIcon.module.scss";

type TurtleIconProps = {
    size?: number;
    className?: string;
    // Paddling legs are the default everywhere the turtle appears as a live
    // mascot (header logo, かめ assistant). Badges/icons that reuse this same
    // artwork as a static image (e.g. achievement badges) opt out.
    animated?: boolean;
};

// Drawn turtle avatar: shell fills almost the entire viewBox, with the 亀
// (turtle) kanji set into the carapace. Head/legs/tail peek out from behind
// the shell, top-down-view style.
function TurtleIcon({ size = 64, className, animated = true }: TurtleIconProps) {
    const legClass = (position: keyof typeof styles) => (animated ? `${styles.leg} ${styles[position]}` : undefined);

    return (
        <svg
            viewBox="0 0 100 100"
            width={size}
            height={size}
            className={className}
            role="img"
            aria-hidden="true"
        >
            <ellipse
                className={legClass("legFrontLeft")}
                cx="17"
                cy="27"
                rx="12"
                ry="9"
                fill="#7fbf6a"
                transform="rotate(-35 17 27)"
            />
            <ellipse
                className={legClass("legFrontRight")}
                cx="83"
                cy="27"
                rx="12"
                ry="9"
                fill="#7fbf6a"
                transform="rotate(35 83 27)"
            />
            <ellipse
                className={legClass("legBackLeft")}
                cx="14"
                cy="77"
                rx="12"
                ry="9"
                fill="#7fbf6a"
                transform="rotate(25 14 77)"
            />
            <ellipse
                className={legClass("legBackRight")}
                cx="86"
                cy="77"
                rx="12"
                ry="9"
                fill="#7fbf6a"
                transform="rotate(-25 86 77)"
            />

            <path d="M45 95 Q50 104 55 95 Z" fill="#7fbf6a" />

            <ellipse cx="50" cy="15" rx="16" ry="14" fill="#8fcc7a" />
            <circle cx="43" cy="12" r="2.6" fill="#22331f" />
            <circle cx="57" cy="12" r="2.6" fill="#22331f" />

            <circle cx="50" cy="54" r="42" fill="#3e8b50" stroke="#2b6a3a" strokeWidth="3" />
            <path
                d="M50 16 L50 92 M12 54 L88 54 M22 24 L78 84 M78 24 L22 84"
                stroke="#357c47"
                strokeWidth="2"
                opacity="0.5"
            />

            <circle cx="50" cy="54" r="30" fill="#458f58" stroke="#2b6a3a" strokeWidth="1.5" opacity="0.85" />

            <text
                x="50"
                y="54"
                textAnchor="middle"
                dominantBaseline="central"
                fontSize="42"
                fontWeight="700"
                fill="#fbf3de"
                fontFamily="'Hiragino Sans', 'Yu Gothic', 'Noto Sans JP', sans-serif"
            >
                亀
            </text>
        </svg>
    );
}

export default TurtleIcon;
